import Vue from 'vue'
import XEUtils from 'xe-utils'
import VXETable from 'vxe-table'
import FilterInput from '@/components/vxetable/FilterInput.vue'
import FilterInputRange from '@/components/vxetable/FilterInputRange.vue'
import FilterDate from '@/components/vxetable/FilterDate.vue'
import FilterExtend from '@/components/vxetable/FilterExtend.vue'
Vue.component(FilterInput.name, FilterInput)
Vue.component(FilterInputRange.name, FilterInputRange)
Vue.component(FilterDate.name, FilterDate)
Vue.component(FilterExtend.name, FilterExtend)
/**
 * 格式化单元格
 */
VXETable.formats.mixin({
  // 格式化日期，yyyy-MM-dd HH:mm:ss 默认 yyyy-MM-dd
  formatDate({ cellValue }, format) {
    var date = new Date(cellValue)
    if (!cellValue || !date || date.getFullYear() === 1900) {
      return ''
    } else {
      return XEUtils.toDateString(date, format || 'yyyy-MM-dd')
    }
  },
  formatZeroNumber({ cellValue }, digits) {
    if (parseFloat(cellValue)) {
      if (digits) {
        return parseFloat(cellValue).toFixed(digits)
      } else {
        return cellValue
      }
    } else {
      return ''
    }
  },
  // 格式金额，默认2位数,是否有权限显示金额
  formatAmount({ cellValue }, digits, ifShowMoney) {
    if (ifShowMoney === false) {
      return '***'
    } else {
      let amount = Number(cellValue) ? Number(cellValue) : 0
      return XEUtils.commafy(amount, { digits: digits || 2 })
    }
  }
})
VXETable.renderer.mixin({
  // 显示红色模板
  InputRedColor: {
    // 可编辑显示模板
    renderCell(h, renderOpts, param) {
      let { row, column } = param
      if (row['dRunnigState'] === '闲置' || row['dRunnigState'] === '报废') {
        return [<span style='color:#FF0000'>{row[column.property]}</span>]
      } else {
        // 默认渲染方式
        return [<span>{row[column.property]}</span>]
      }
    }
  },
  // 列直接显示成蓝色
  ColumnBlueColor: {
    // 可编辑显示模板
    renderDefault(h, renderOpts, param) {
      let { row, column } = param
      return [<span style='color:#00BFFF'>{row[column.property]}</span>]
    }
  },
  // 列直接显示成红色
  ColumnRedColor: {
    // 可编辑显示模板
    renderDefault(h, renderOpts, param) {
      let { row, column } = param
      return [<span style='color:#FF0000'>{row[column.property]}</span>]
    }
  },
  // 列字体直接加粗加蓝色
  // 目前是包装清单和部件包装清单用
  ColumnFontBlueColor: {
    // 可编辑显示模板
    renderDefault(h, renderOpts, param) {
      let { row, column } = param
      if (row['wpdIsM'] > 0) {
        return [<span style='font-weight: bold;color:#00BFFF'>{row[column.property]}</span>]
      } else {
        return [<span>{row[column.property]}</span>]
      }
    }
  },
  // 列直接显示成红色
  ColumnRedColorFormatter: {
    // 可编辑显示模板
    renderDefault(h, renderOpts, param) {
      let { row, column } = param
      if (row[column.property] > 0) {
        return [<span style='color:#FF0000'>是</span>]
      } else {
        return [<span style='color:#FF0000'>否</span>]
      }
    }
  },
  // 创建一个简单的输入框筛选
  FilterInput: {
    // 筛选模板
    renderFilter(h, renderOpts, params) {
      return [<filter-input params={params} key={params.$columnIndex}></filter-input>]
    },
    // 重置数据方法
    filterResetMethod({ options }) {
      options.forEach(option => {
        option.data = ''
      })
    },
    // 重置筛选复原方法（当未点击确认时，该选项将被恢复为默认值）
    filterRecoverMethod({ option }) {
      option.data = ''
    },
    // 筛选方法
    filterMethod({ option, row, column }) {
      const { data } = option
      const cellValue = XEUtils.get(row, column.property) + ''
      if (cellValue) {
        return cellValue.indexOf(data) > -1
      }
      return false
    }
  },
  // 创建一个简单的输入框筛选
  FilterDate: {
    // 筛选模板
    renderFilter(h, renderOpts, params) {
      return [<filter-date params={params} key={params.$columnIndex}></filter-date>]
    },
    // 重置数据方法
    filterResetMethod({ options }) {
      options.forEach(option => {
        option.data = { start: '', end: '' }
        // option.start = ''
        // option.end = ''
      })
    },
    // 筛选方法
    filterMethod({ option, row, column }) {
      const cellValue = XEUtils.toDateString(XEUtils.get(row, column.property), 'yyyy-MM-dd')
      const start = XEUtils.toDateString(option.data.start, 'yyyy-MM-dd')
      const end = XEUtils.toDateString(option.data.end, 'yyyy-MM-dd')
      if (cellValue) {
        if (start && end) {
          return cellValue >= start && cellValue <= end
        } else if (start) {
          return cellValue >= start
        } else if (end) {
          return cellValue <= end
        }
      }
      return false
    }
  },
  // 数字范围筛选器
  FilterInputRange: {
    // 筛选模板
    renderFilter(h, renderOpts, params) {
      return [<filter-input-range params={params} key={params.$columnIndex}></filter-input-range>]
    },
    // 重置数据方法
    filterResetMethod({ options }) {
      options.forEach(option => {
        option.data = {
          val1: '',
          val2: ''
        }
      })
    },
    // 筛选方法
    filterMethod({ option, row, column }) {
      const { data } = option
      const cellValue = XEUtils.get(row, column.property) + ''

      // 若未输入任何值，则显示所有
      if (data.val1.trim() === '' && data.val2.trim() === '') return true

      // 提取出内容中的数字，如 T150 -> 150
      let curValue = Number(cellValue.match(/(\d)+/g)[0])
      // 起始值
      let numVal1 = isNaN(Number(data.val1)) ? '' : Number(data.val1)
      // 结束值
      let numVal2 = isNaN(Number(data.val2)) ? '' : Number(data.val2)

      // 不输入或输入非数字时，转为空字符串，会只过滤单个输入框的值（如输入值为 "2~我是中文"，则只会显示第2条）
      if (data.val1 === '' || numVal1 === '') {
        return curValue === numVal2
      }
      if (data.val2 === '' || numVal2 === '') {
        return curValue === numVal1
      }

      // 输入0~xx时，取范围（如输入 "0~22"，则会显示前22条）
      if (!isNaN(curValue)) {
        let max = Math.max(numVal1, numVal2)
        let min = Math.min(numVal1, numVal2)
        return curValue >= min && curValue <= max
      }
      return false
    }
  }
})

// 创建一个复杂的筛选器（包含输入框、勾选框）
// 注意！必须用 add 来添加模板，使用 mixin 无效果
VXETable.renderer.add('FilterExtend', {
  // 不显示底部按钮，使用自定义的按钮
  isFooter: false,
  // 筛选模板
  renderFilter(h, renderOpts, params) {
    // 注意！key必须要有！避免直接点击筛选按钮时，旧的组件不会销毁。params.$columnIndex 为列索引
    return [
      <filter-extend params={params} valueFormat={renderOpts.valueFormat} key={params.$columnIndex}></filter-extend>
    ]
  },
  // 重置数据方法
  filterResetMethod({ options }) {
    options.forEach(option => {
      option.data = {
        vals: [],
        sVal: '',
        fMenu: '',
        f1Type: '',
        f1Val: '',
        fMode: 'and',
        f2Type: '',
        f2Val: ''
      }
    })
  },
  // 筛选数据方法
  filterMethod({ option, row, column }) {
    const cellValue = row[column.property]
    const { vals, f1Type, f1Val } = option.data
    // 需注释掉该行，不然空字符串会判断不到 if (cellValue) {
    if (f1Type) {
      return cellValue.indexOf(f1Val) > -1
    } else if (vals.length) {
      // 注意！必须转为string，不然数字会过滤不到
      const str = cellValue.toString()
      // 通过指定值筛选
      return vals.includes(str)
    }
    // }
    return false
  }
})
